/* global BigInt */
import React, { Component } from "react";
import { Translate, I18n } from "react-redux-i18n";
import { Form } from "react-bootstrap";
import axios, { CancelToken } from "axios";
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";
import { CountryDropdown } from "react-country-region-selector";
import { setAlert } from "../../../actions/alertActions";
import {
  getCountryCode,
  getCountryName,
  byteManipModule,
} from "../../utils/Utils";
import "../../../styles/components/evs/modals/RequestNetworkAccess.scss";
import "../../../styles/components/evs/modals/requestCard.css";
import iconInfo from "../../../styles/images/iconInfo.svg";
import arrow from "../../../styles/images/back_arrow.svg";
import ConfirmBlock from "../../../components/evs/modals/ConfirmBlock.js";


const { dec2hex, hex2dec, swapEndian, invertDec } = byteManipModule;
class RequestPhysicalCard extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    const homePlace =
      this.props.accountData.places &&
      this.props.accountData.places.filter((obj) => obj.name === "home")[0];
    const workPlace =
      this.props.accountData.places &&
      this.props.accountData.places.filter((obj) => obj.name === "work")[0];

    this.state = {
      confirmBlock: false,
      cancelCardSuccess: false,
      cardNameWasEdited: false,
      LicensePlateWasEdited: false,
      identification_name: this.getInitialIdentificationName(props),
      identification_license_plate:
        this.getInitialIdentificationLicensePlate(props),
      identification_sent_to: this.getInitialIdentificationName(props) || "",
      identification_care_of: null,
      identification_other_text: "",
      identification_nif: null,
      identification_address:
        homePlace?.address?.street !== ""
          ? homePlace?.address?.street
          : this.props.accountData.billingAddress?.address !== ""
          ? this.props.accountData.billingAddress?.address
          : "",
      identification_number:
        homePlace?.address?.street !== ""
          ? homePlace?.address?.number
          : this.props.accountData.billingAddress?.address !== ""
          ? this.props.accountData.billingAddress?.number
          : "",
      identification_floor:
        homePlace?.address?.street !== ""
          ? homePlace?.address?.floor
          : this.props.accountData.billingAddress?.address !== ""
          ? this.props.accountData.billingAddress?.floor
          : "",
      identification_phone: null,
      identification_zipcode:
        homePlace?.address?.street !== ""
          ? homePlace?.address?.zipCode
          : this.props.accountData.billingAddress?.address !== ""
          ? this.props.accountData.billingAddress?.postCode
          : "",
      identification_country:
        homePlace?.address?.country ||
        workPlace?.address?.country ||
        "Portugal",
      identification_city:
        homePlace?.address?.street !== ""
          ? homePlace?.address?.city
          : this.props.accountData.billingAddress?.address !== ""
          ? this.props.accountData.billingAddress?.city
          : "",
      identification_state:
        homePlace?.address?.street !== ""
          ? homePlace?.address?.state
          : this.props.accountData.billingAddress?.address !== ""
          ? this.props.accountData.billingAddress?.state
          : "",
      rfid_little_endian: "00000000",
      rfid_big_endian: "00000000",
      rfid_decimal: 0,
      rfid_inverted_decimal: "00000000",
      card_number: "",
      address_value:
        homePlace?.address?.street !== ""
          ? "address-home"
          : this.props.accountData.billingAddress?.address !== ""
          ? "address-billing"
          : "address-other",
      is_address: false,

      identification_name_valid: true,
      identification_contract_name_valid: true,
      identification_license_plate_valid: true,
      identification_sent_to_valid: true,
      identification_nif_valid: false,
      identification_address_valid:
        this.props.accountData.places &&
        this.props.accountData.places.length === 0 &&
        this.props.accountData.billingAddress.length === 0
          ? false
          : homePlace?.address?.street !== "" ||
            this.props.accountData.billingAddress?.address !== ""
          ? true
          : false,
      identification_phone_valid: false,
      identification_zipcode_valid:
        this.props.accountData.places &&
        this.props.accountData.places.length === 0 &&
        this.props.accountData.billingAddress.length === 0
          ? false
          : homePlace?.address?.street !== "" ||
            this.props.accountData.billingAddress?.address !== ""
          ? true
          : false,
      identification_country_valid: true,
      identification_city_valid:
        this.props.accountData.places &&
        this.props.accountData.places.length === 0 &&
        this.props.accountData.billingAddress.length === 0
          ? false
          : homePlace?.address?.street !== "" ||
            this.props.accountData.billingAddress?.address !== ""
          ? true
          : false,
      identification_state_valid:
        this.props.accountData.places &&
        this.props.accountData.places.length === 0 &&
        this.props.accountData.billingAddress.length === 0
          ? false
          : homePlace?.address?.street !== "" ||
            this.props.accountData.billingAddress?.address !== ""
          ? true
          : false,
      rfid_little_endian_valid: false,
      rfid_big_endian_valid: false,
      rfid_decimal_valid: false,
      rfid_inverted_decimal_valid: false,
      card_number_valid: false,
    };

    this.calculateEndiansAndInverted =
      this.calculateEndiansAndInverted.bind(this);
    this.filterSpecialCharacters = this.filterSpecialCharacters.bind(this);
  }

  getInitialIdentificationName(props) {
    return props.selectedEV?.contract?.name
      ? props.selectedEV.contract.name.replace(/^(.{30}).{2,}/, "$1")
      : "";
  }

  getInitialIdentificationLicensePlate(props) {
    return props.selectedEV?.contract?.cardName
      ? props.selectedEV.contract.cardName.replace(/^(.{30}).{2,}/, "$1")
      : "";
  }

  handleOnChange(reg, e) {
    if (e.target.name === "identification_nif") {
      if (this.isNifValid(e)) {
        this.safeSetState({
          [e.target.name + "_valid"]: true,
        });
      } else {
        this.safeSetState({
          [e.target.name + "_valid"]: false,
        });
      }
    } else if (e.target.name === "rfid_decimal") {
      this.calculateEndiansAndInverted(e.target.value);

      if (
        BigInt(e.target.value) <= BigInt("0xffffffffffffff") &&
        this.validateFormComponent(e.target.value, reg)
      ) {
        this.safeSetState({
          [e.target.name + "_valid"]: true,
        });
      } else {
        this.safeSetState({
          [e.target.name + "_valid"]: false,
        });
      }
    } else {
      const { name, value } = e.target;
      const isZipcode = name === "identification_zipcode";
      const isForeignCountry = this.state.identification_country !== "Portugal";

      if (isZipcode && isForeignCountry) {
        this.safeSetState({ [`${name}_valid`]: true });
      } else {
        const isValid = this.validateFormComponent(value, reg);
        this.safeSetState({ [`${name}_valid`]: isValid });
      }
    }

    this.safeSetState({
      [e.target.name]: this.filterSpecialCharacters(e.target.value),
    });
  }

  filterSpecialCharacters(input) {
    if (!input) return input;
    return input
      .replace(/[\s\u00A0]+/g, " ")
      .replace(/[^a-zA-Z0-9 \-.'\u00C0-\u024F]/g, "");
  }

  handleOnSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true });
    if (this.props.requestNewPhysicalCard) {
      this.safeSetState({ confirmBlock: true, loading: false });
    } else {
      this.submitRequest();
    }
  }

  handleOnSubmitAssociate(e) {
    e.preventDefault();
    this.submitAssociateRequest();
  }

  validateFormComponent(value, reg) {
    if (value.match(reg)) {
      return true;
    } else {
      return false;
    }
  }

  handleChangeSelect(e) {
    e.preventDefault();

    this.safeSetState({
      address_value: e.target.value,
    });

    if (e.target.value !== "address-other") {
      this.safeSetState({
        identification_address:
          e.target.value === "address-home"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "home"
              )[0]?.address.street
            : e.target.value === "address-work"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "work"
              )[0]?.address.street
            : this.props.accountData.billingAddress?.address,
        identification_city:
          e.target.value === "address-home"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "home"
              )[0]?.address.city
            : e.target.value === "address-work"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "work"
              )[0]?.address.city
            : this.props.accountData.billingAddress?.city,
        identification_zipcode:
          e.target.value === "address-home"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "home"
              )[0]?.address.zipCode
            : e.target.value === "address-work"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "work"
              )[0]?.address.zipCode
            : this.props.accountData.billingAddress?.postCode,
        identification_country:
          e.target.value === "address-home"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "home"
              )[0]?.address.country
            : e.target.value === "address-work"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "work"
              )[0]?.address.country
            : this.props.accountData.billingAddress?.country,
        identification_number:
          e.target.value === "address-home"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "home"
              )[0]?.address.number
            : e.target.value === "address-work"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "work"
              )[0]?.address.number
            : this.props.accountData.billingAddress?.number,
        identification_floor:
          e.target.value === "address-home"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "home"
              )[0]?.address.floor
            : e.target.value === "address-work"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "work"
              )[0]?.address.floor
            : this.props.accountData.billingAddress?.floor,
        identification_state:
          e.target.value === "address-home"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "home"
              )[0]?.address.state
            : e.target.value === "address-work"
            ? this.props.accountData.places &&
              this.props.accountData.places.filter(
                (obj) => obj.name === "work"
              )[0]?.address.state
            : this.props.accountData.billingAddress?.state,
        is_address: true,

        identification_address_valid: true,
        identification_city_valid: true,
        identification_zipcode_valid: true,
        identification_country_valid: true,
        identification_state_valid: true,
      });
    } else {
      this.safeSetState({
        identification_address: "",
        identification_city: "",
        identification_zipcode: "",
        identification_number: "",
        identification_floor: "",
        identification_state: "",
        identification_country:
          this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.country ||
          this.props.accountData.places.filter((obj) => obj.name === "work")[0]
            ?.address.country ||
          "Portugal",
        identification_address_valid: false,
        identification_city_valid: false,
        identification_zipcode_valid: false,
        identification_country_valid: true,
        identification_state_valid: false,
      });
    }
  }

  calculateEndiansAndInverted(value) {
    const byteNumber = BigInt(value) > 2 ** 32 ? 7 : 4;
    this.safeSetState(
      {
        rfid_decimal: String(value),
      },
      () => {
        this.safeSetState(
          {
            rfid_little_endian: String(dec2hex(value, byteNumber)),
            rfid_little_endian_valid: true,
          },
          () =>
            this.safeSetState(
              {
                rfid_big_endian: String(
                  swapEndian(this.state.rfid_little_endian)
                ),
                rfid_big_endian_valid: true,
              },
              () =>
                this.safeSetState({
                  rfid_inverted_decimal: String(
                    hex2dec(this.state.rfid_big_endian)
                  ),
                  rfid_inverted_decimal_valid: true,
                })
            )
        );
      }
    );
  }

  submitAssociateRequest() {
    if (
      this.state.rfid_little_endian_valid &&
      this.state.rfid_big_endian_valid &&
      this.state.rfid_decimal_valid
    ) {
      const patch = {
        idTagDec: this.state.rfid_inverted_decimal,
        idTagHexa: this.state.rfid_little_endian,
        idTagHexaInv: this.state.rfid_big_endian,
        cardNumber: this.state.card_number,
        contractId: this.props.selectedEV
          ? this.props.selectedEV?.contract?._id
          : this.props.selectedContract?._id,
      };

      axios
        .patch(
          `/api/private/contracts/${
            this.props.associatedEdit
              ? "editAssociatePhysicalCard"
              : "associatePhysicalCard"
          }`,
          patch
        )
        .then((res) => {
          if (res.status === 200) {
            this.props.setAlert(
              I18n.t("backOffice_associate_card_request_success_alert"),
              "primary"
            );
            this.props.fetchFleets();
            this.props.onHide();
          }
        })
        .catch((err) =>
          this.props.setAlert(I18n.t(err.response.data.code), "danger")
        );
    } else {
      this.props.setAlert(
        I18n.t("backOffice_network_request_verifyForm_alert"),
        "danger"
      );
    }
  }

  async submitRequest() {
    if (
      this.state.identification_address_valid &&
      this.state.identification_zipcode_valid &&
      this.state.identification_country_valid &&
      this.state.identification_city_valid &&
      this.state.identification_state_valid &&
      this.state.identification_name_valid
    ) {
      const patch = {
        _id: this.props.selectedEV
          ? this.props.selectedEV.contract._id
          : this.props.selectedContract._id,
        name: this.props.selectedEV
          ? this.props.selectedEV.contract.name
          : this.props.selectedContract.name,
        email: this.props.selectedEV
          ? this.props.selectedEV.contract.email
          : this.props.selectedContract.email,
        internationalPrefix: this.props.selectedEV
          ? this.props.selectedEV.contract.internationalPrefix
          : this.props.selectedContract.internationalPrefix,
        mobile: this.props.selectedEV
          ? this.props.selectedEV.contract.mobile
          : this.props.selectedContract.mobile,
        cardPhysicalName: this.state.identification_name
          ? this.state.identification_name
          : this.props.selectedEV
          ? this.props.selectedEV?.contract?.name.replace(/^(.{30}).{2,}/, "$1")
          : this.props.selectedContract?.name.replace(/^(.{30}).{2,}/, "$1"),
        cardPhysicalLicensePlate: this.state.identification_license_plate
          ? this.state.identification_license_plate
          : this.props.selectedEV
          ? this.props.selectedEV?.contract?.cardName.replace(
              /^(.{15}).{2,}/,
              "$1"
            )
          : this.props.selectedContract?.cardName.replace(
              /^(.{15}).{2,}/,
              "$1"
            ),
        cardPhysicalSendTo: this.state.identification_sent_to,
        cardPhysicalInTheCareOf: this.state.identification_care_of,
        cardPhysicalText: this.state.identification_other_text,
        paymentMethod: "string",
        address: {
          street: this.state.identification_address,
          zipCode: this.state.identification_zipcode,
          number: this.state.identification_number,
          floor: this.state.identification_floor,
          country: this.state.identification_country
            ? this.state.identification_country
            : "Portugal",
          countryCode: getCountryCode(this.state.identification_country)
            ? getCountryCode(this.state.identification_country)
            : "PT",
          city: this.state.identification_city,
          state: this.state.identification_state,
        },
      };

      this.safeSetState({ confirmBlock: false });

      if (this.props.requestNewPhysicalCard) {
        let reasons = this.props?.reasonsCarryOverToRequestPhysicalCard;
        try {
          const res = await axios.patch("/api/private/contracts/cancelRFID", {
            ...reasons,
            cancelToken: new CancelToken((c) => (this.cancel = c)),
          });
          if (res.status === 200) {
            this.safeSetState({ cancelCardSuccess: true });
          }
        } catch (err) {
          this.safeSetState({ cancelCardSuccess: false });
          this.props.setAlert(err?.response?.data?.message, "danger");
          this.setState({ loading: false });
          return;
        }
      }

      axios
        .patch("/api/private/contracts/requestPhysicalCard", patch)
        .then((res) => {
          if (res.status === 200) {
            this.props.setAlert(
              I18n.t("backOffice_physical_card_request_success_alert"),
              "primary"
            );
            this.props.fetchFleets();
            if (
              this.props.requestNewPhysicalCard &&
              this.props.onCloseParentModal
            ) {
              this.props.setAlert(
                I18n.t(
                  "contractsPhysicalCard_messageSuccessCanceledWithNewCard"
                ),
                "primary"
              );
              this.props.onCloseParentModal();
            } else {
              this.props.setAlert(
                I18n.t("backOffice_physical_card_request_success_alert"),
                "primary"
              );
            }
            this.props.onHide();
          }
        })
        .catch((err) => {
          this.setState({ loading: false });
          this.props.setAlert(err?.response?.data?.message, "danger");
        });
    } else {
      if (!this.state.identification_address_valid) {
        this.props.setAlert(
          I18n.t("backOffice_network_request_verifyAddress_alert"),
          "danger"
        );
      } else if (!this.state.identification_zipcode_valid) {
        this.props.setAlert(
          I18n.t("backOffice_network_request_verifyZipCode_alert"),
          "danger"
        );
      } else if (!this.state.identification_country_valid) {
        this.props.setAlert(
          I18n.t("backOffice_network_request_verifyCountry_alert"),
          "danger"
        );
      } else if (!this.state.identification_city_valid) {
        this.props.setAlert(
          I18n.t("backOffice_network_request_verifyCity_alert"),
          "danger"
        );
      } else if (!this.state.identification_state_valid) {
        this.props.setAlert(
          I18n.t("backOffice_network_request_verifyState_alert"),
          "danger"
        );
      } else if (!this.state.identification_name_valid) {
        this.props.setAlert(
          I18n.t("backOffice_network_request_verifyName_alert"),
          "danger"
        );
      } else {
        this.props.setAlert(
          I18n.t("backOffice_network_request_verifyForm_alert"),
          "danger"
        );
      }
    }
  }

  handleConfirmBlockSuccess = () => {
    this.submitRequest();
  };

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedEV !== this.props.selectedEV) {
      this.setState({
        identification_name: this.getInitialIdentificationName(this.props),
        identification_license_plate: this.getInitialIdentificationLicensePlate(
          this.props
        ),
      });
    }

    if (prevProps.selectedEV !== this.props.selectedEV) {
      this.setState({
        identification_name: this.getInitialIdentificationName(this.props),
        identification_license_plate: this.getInitialIdentificationLicensePlate(
          this.props
        ),
      });
    }

    if (
      this.props.associate &&
      this.props.associatedEdit &&
      this.props.hasOwnProperty("selectedContract") &&
      this.props.selectedContract
    ) {
      if (
        prevProps.selectedContract !== this.props.selectedContract ||
        prevProps.selectedContract._id !== this.props.selectedContract._id
      ) {
        const RFID = this.props.selectedContract.networks[0].tokens.find(
          (token) => token.tokenType === "RFID"
        );
        if (RFID) {
          const idTagDec = RFID.idTagDec;
          const byteNumber = BigInt(idTagDec) > 2 ** 32 ? 7 : 4;
          this.calculateEndiansAndInverted(invertDec(idTagDec, byteNumber));
          this.safeSetState({
            card_number: this.props.selectedContract.cardNumber,
            rfid_decimal_valid: true,
          });
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.cancel !== null) this.cancel("Component is unmounting");
    this._mounted = false;
  }

  resetState() {
    this.safeSetState({
      identification_name: this.getInitialIdentificationName(this.props),
      identification_license_plate: this.getInitialIdentificationLicensePlate(
        this.props
      ),
      identification_sent_to:
        this.getInitialIdentificationName(this.props) || "",
      identification_care_of: null,
      identification_other_text: "",
      identification_nif: null,
      identification_address: !this.props.accountData?.places
        ? ""
        : this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.street !== ""
        ? this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.street
        : this.props.accountData.billingAddress?.address !== ""
        ? this.props.accountData.billingAddress?.address
        : "",
      identification_number: !this.props.accountData?.places
        ? ""
        : this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.street !== ""
        ? this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.number
        : this.props.accountData.billingAddress?.address !== ""
        ? this.props.accountData.billingAddress?.number
        : "",
      identification_floor: !this.props.accountData?.places
        ? ""
        : this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.street !== ""
        ? this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.floor
        : this.props.accountData.billingAddress?.address !== ""
        ? this.props.accountData.billingAddress?.floor
        : "",
      identification_phone: null,
      identification_zipcode: !this.props.accountData?.places
        ? ""
        : this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.street !== ""
        ? this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.zipCode
        : this.props.accountData.billingAddress?.address !== ""
        ? this.props.accountData.billingAddress?.postCode
        : "",
      identification_country:
        this.props.accountData.places.filter((obj) => obj.name === "home")[0]
          ?.address.country ||
        this.props.accountData.places.filter((obj) => obj.name === "work")[0]
          ?.address.country ||
        "Portugal",
      identification_city: !this.props.accountData?.places
        ? ""
        : this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.street !== ""
        ? this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.city
        : this.props.accountData.billingAddress?.address !== ""
        ? this.props.accountData.billingAddress?.city
        : "",
      identification_state: !this.props.accountData?.places
        ? ""
        : this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.street !== ""
        ? this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.state
        : this.props.accountData.billingAddress?.address !== ""
        ? this.props.accountData.billingAddress?.state
        : "",
      address_value: !this.props.accountData?.places
        ? ""
        : this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.street !== ""
        ? "address-home"
        : this.props.accountData.billingAddress?.address !== ""
        ? "address-billing"
        : "address-other",
      is_address: false,

      identification_name_valid: true,
      identification_contract_name_valid: true,
      identification_license_plate_valid: null,
      identification_sent_to_valid: null,
      identification_nif_valid: false,
      identification_address_valid: !this.props.accountData?.places
        ? ""
        : this.props.accountData?.places?.length === 0 &&
          this.props.accountData.billingAddress.length === 0
        ? false
        : this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.street !== "" ||
          this.props.accountData.billingAddress?.address !== ""
        ? true
        : false,
      identification_phone_valid: false,
      identification_zipcode_valid: !this.props.accountData?.places
        ? ""
        : this.props.accountData.places.length === 0 &&
          this.props.accountData.billingAddress.length === 0
        ? false
        : this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.street !== "" ||
          this.props.accountData.billingAddress?.address !== ""
        ? true
        : false,
      identification_country_valid: true,
      identification_city_valid: !this.props.accountData?.places
        ? ""
        : this.props.accountData.places.length === 0 &&
          this.props.accountData.billingAddress.length === 0
        ? false
        : this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.street !== "" ||
          this.props.accountData.billingAddress?.address !== ""
        ? true
        : false,
      identification_state_valid: !this.props.accountData?.places
        ? ""
        : this.props.accountData.places.length === 0 &&
          this.props.accountData.billingAddress.length === 0
        ? false
        : this.props.accountData.places.filter((obj) => obj.name === "home")[0]
            ?.address.street !== "" ||
          this.props.accountData.billingAddress?.address !== ""
        ? true
        : false,

      rfid_little_endian: "00000000",
      rfid_big_endian: "00000000",
      rfid_decimal: 0,
      rfid_inverted_decimal: "00000000",
      card_number: null,

      rfid_little_endian_valid: false,
      rfid_big_endian_valid: false,
      rfid_decimal_valid: false,
      rfid_inverted_decimal_valid: false,
      card_number_valid: false,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    const labelInfoClass =
      this.state.identification_name === "" ? "invalid-label-info" : "";
    const labelInfoClassLp =
      this.state.identification_license_plate === ""
        ? "invalid-label-info"
        : "";

    return (
      <Modal
        id="requestPhysicalCard"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.resetState.bind(this)}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            {this.props.requestNewPhysicalCard ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src={arrow}
                  alt="Return"
                  className="arrow requestCardImage"
                  onClick={this.props.onHide}
                  aria-label="Back"
                />
                <span className="requestPhysicalCardTitleSpan">
                  <Translate value="backOffice_network_request_physicalCard_bt" />
                </span>
              </div>
            ) : !this.props.associate ? (
              <Translate value="backOffice_network_request_physicalCard_bt" />
            ) : (
              <Translate value="backOffice_network_associate_physicalCard_bt" />
            )}
          </Modal.Title>
        </Modal.Header>
        <div className="evio-card-container">
          <div
            className="evio-card"
            style={{
              ...(this.props.brand &&
                this.props.brand.brandName !== "EVIO" && {
                  backgroundImage: `url('${
                    this.props.brand.icons?.cards?.big ?? ""
                  }')`,
                }),
            }}
          >
            {this.props.selectedContract && (
              <span>
                <p>{this.props.selectedContract.name}</p>
                <p>{this.props.selectedContract.cardName}</p>
              </span>
            )}

            {this.props.selectedEV && !this.props.associate && (
              <div className="cardGroupsRow">
                <div className="cardsGroupColumn">
                  <div className="cardPrimaryText">
                    {this.state?.identification_name !== "" ||
                    this.props?.selectedContract?.name === undefined ? (
                      <p className="override">
                        {this.state?.identification_name}
                      </p>
                    ) : (
                      <p className="override">
                        {this.props?.selectedContract.name}
                      </p>
                    )}
                  </div>

                  <div className="cardPrimaryText">
                    {this.props.selectedEV?.contract?.cardName !== undefined ? (
                      <p className="override">
                        {this.props.selectedEV?.contract?.cardName}
                      </p>
                    ) : (
                      <p className="width13">
                        {this.state?.identification_license_plate}
                      </p>
                    )}
                  </div>
                </div>
                <div className="cardsGroupColumn">
                  <div className="cardOtherText">
                    <p>{this.state?.identification_other_text}</p>
                  </div>
                </div>
              </div>
            )}
            {this.props.selectedContract && (
              <span className="cardNumberOne">
                <p>{this.props?.selectedContract?.cardNumber}</p>
              </span>
            )}

            {this.props.selectedEV && !this.props.associate && (
              <span className="evio-card-number-absolute">
                <p>{this.props?.selectedEV?.contract?.cardNumber}</p>
              </span>
            )}
          </div>
        </div>

        <Modal.Body>
          <div id="join">
            {!this.props.associate ? (
              /*
                REQUEST PHYSICAL CARD 
              */

              <Form
                id="requestPhysicalCard-form"
                onSubmit={this.handleOnSubmit.bind(this)}
              >
                <div className="content-section">
                  <div className="content">
                    <div className="item">
                      <div className="f-field fullWidth">
                        <div className="label alignTooltips">
                          <div className="descriptionDiv">
                            <p className="descriptionP">
                              {I18n.t("requestCard_primaryText")}
                            </p>
                          </div>
                          <div
                            data-tooltip={I18n.t(
                              "requestCard_primaryTextTooltip"
                            )}
                          >
                            <img src={iconInfo} alt="" />
                          </div>
                        </div>
                        <Form.Control
                          required
                          name="identification_name"
                          value={this.state.identification_name}
                          isValid={this.state.identification_name_valid}
                          isInvalid={this.state.identification_name === ""}
                          onChange={this.handleOnChange.bind(this, /.*/)}
                          type="text"
                          maxLength="30"
                        />
                        <div className={`label-info ${labelInfoClass}`}>
                          {I18n.t("cards_maxLimit30")}
                        </div>
                      </div>
                      <div className="f-field fullWidth">
                        <div className="label alignTooltips">
                          <div className="descriptionDiv">
                            <p className="descriptionP">
                              {I18n.t("requestCard_secondaryText")}
                            </p>
                          </div>
                          <div
                            data-tooltip={I18n.t(
                              "requestCard_secondaryTextTooltip"
                            )}
                          >
                            <img src={iconInfo} alt="" />
                          </div>
                        </div>
                        <Form.Control
                          required
                          name="identification_license_plate"
                          value={this.state.identification_license_plate}
                          maxLength="30"
                          isInvalid={
                            this.state.identification_license_plate.length > 30
                          }
                          onChange={this.handleOnChange.bind(this, /.*/)}
                          type="text"
                        />
                        <div className={`label-info ${labelInfoClassLp}`}>
                          {I18n.t("cards_maxLimit30")}
                        </div>
                      </div>
                      <div className="break" />
                      <div className="f-field">
                        <div className="label">{I18n.t("cards_otherText")}</div>
                        <Form.Control
                          value={this.state?.identification_other_text}
                          name="identification_other_text"
                          onChange={this.handleOnChange.bind(this, /.*/)}
                          type="text"
                          maxLength="15"
                        />
                        <div className="label-info">
                          {I18n.t("cards_maxLimit15")}
                        </div>
                      </div>
                      <div className="break" />
                      <div className="f-field">
                        <div className="label">{I18n.t("evs_recipient")}</div>
                        <Form.Control
                          required
                          name="identification_sent_to"
                          value={this.state.identification_sent_to}
                          isValid={this.state.identification_sent_to_valid}
                          isInvalid={this.state.identification_sent_to === ""}
                          onChange={this.handleOnChange.bind(this, /.*/)}
                          type="text"
                        />
                      </div>

                      <div className="f-field">
                        <div className="label">{I18n.t("evs_CareOf")}</div>
                        <Form.Control
                          name="identification_care_of"
                          value={
                            this.state.identification_care_of
                              ? this.state.identification_care_of
                              : ""
                          }
                          onChange={this.handleOnChange.bind(this, /.*/)}
                          type="text"
                        />
                      </div>
                      <div className="break" />
                      {((this.props.accountData.places &&
                        this.props.accountData.places.filter(
                          (obj) => obj.name === "home"
                        )[0]?.address.street) ||
                        (this.props.accountData.places &&
                          this.props.accountData.places.filter(
                            (obj) => obj.name === "work"
                          )[0]?.address.street) ||
                        this.props.accountData.billingAddress?.address) && (
                        <div className="f-field auto50">
                          <div className="label">
                            <Translate value="backOffice_network_forms_contractSelectAddress" />
                          </div>
                          <div className="select-container">
                            <select
                              onChange={(e) => this.handleChangeSelect(e)}
                              value={this.state.address_value}
                            >
                              <option value="address-other">
                                {I18n.t(
                                  "backOffice_network_forms_contractOtherAddress"
                                )}
                              </option>
                              {((this.props?.accountData?.places &&
                                this.props?.accountData?.places.filter(
                                  (obj) => obj.name === "home"
                                )[0]?.address.street) ||
                                (this.props?.accountData?.places &&
                                  this.props?.accountData?.places.filter(
                                    (obj) => obj.name === "work"
                                  )[0]?.address.street)) &&
                                this.props?.accountData?.places &&
                                this.props?.accountData?.places.map(
                                  (item, index) =>
                                    item.address.street !== "" && (
                                      <option
                                        key={index}
                                        value={`address-${item.name}`}
                                        title={item.address.street}
                                      >
                                        {item.address.street.length > 30
                                          ? item.address.street.slice(0, 30) +
                                            "..."
                                          : item.address.street}
                                      </option>
                                    )
                                )}
                              {this.props?.accountData?.billingAddress
                                ?.address && (
                                <option value="address-billing">
                                  {
                                    this.props?.accountData?.billingAddress
                                      ?.address
                                  }
                                </option>
                              )}
                            </select>
                          </div>
                        </div>
                      )}
                      <div className="f-field auto50">
                        <div className="label">
                          <Translate value="backOffice_network_forms_address_title" />
                        </div>
                        <Form.Control
                          required
                          name="identification_address"
                          value={this.state.identification_address}
                          onChange={this.handleOnChange.bind(this, /.*/)}
                          isValid={this.state.identification_address_valid}
                          type="text"
                          disabled={
                            ((this.props.accountData.places &&
                              this.props.accountData.places.filter(
                                (obj) => obj.name === "home"
                              )[0]?.address.street) ||
                              this.props.accountData.billingAddress?.address) &&
                            this.state.address_value !== "address-other" &&
                            "disabled"
                          }
                        />
                      </div>
                      <div className="break" />
                      <div className="f-field auto50">
                        <div className="label">
                          <Translate value="addAddress_number" />
                        </div>
                        <Form.Control
                          name="identification_number"
                          value={this.state.identification_number}
                          onChange={this.handleOnChange.bind(this, /.*/)}
                          type="text"
                          disabled={
                            ((this.props.accountData.places &&
                              this.props.accountData.places.filter(
                                (obj) => obj.name === "home"
                              )[0]?.address.street) ||
                              this.props.accountData.billingAddress?.address) &&
                            this.state.address_value !== "address-other" &&
                            "disabled"
                          }
                        />
                      </div>
                      <div className="f-field auto50">
                        <div className="label">
                          <Translate value="addAddress_floor" />
                        </div>
                        <Form.Control
                          name="identification_floor"
                          value={this.state.identification_floor}
                          onChange={this.handleOnChange.bind(this, /.*/)}
                          type="text"
                          disabled={
                            ((this.props.accountData.places &&
                              this.props.accountData.places.filter(
                                (obj) => obj.name === "home"
                              )[0]?.address.street) ||
                              this.props.accountData.billingAddress?.address) &&
                            this.state.address_value !== "address-other" &&
                            "disabled"
                          }
                        />
                      </div>
                      <div className="break" />
                      <div className="f-field auto50">
                        <div className="label">
                          <Translate value="backOffice_network_forms_contractStateAddress" />
                        </div>
                        <Form.Control
                          required
                          name="identification_state"
                          value={this.state.identification_state}
                          isValid={this.state.identification_state_valid}
                          onChange={this.handleOnChange.bind(this, /.*/)}
                          type="text"
                          disabled={
                            ((this.props.accountData.places &&
                              this.props.accountData.places.filter(
                                (obj) => obj.name === "home"
                              )[0]?.address.street) ||
                              this.props.accountData.billingAddress?.address) &&
                            this.state.address_value !== "address-other" &&
                            "disabled"
                          }
                        />
                      </div>
                      <div className="f-field auto50">
                        <div className="label">
                          <Translate value="address_city" />
                        </div>
                        <Form.Control
                          required
                          name="identification_city"
                          value={this.state.identification_city}
                          isValid={this.state.identification_city_valid}
                          onChange={this.handleOnChange.bind(this, /.*/)}
                          type="text"
                          disabled={
                            ((this.props.accountData.places &&
                              this.props.accountData.places.filter(
                                (obj) => obj.name === "home"
                              )[0]?.address.street) ||
                              this.props.accountData.billingAddress?.address) &&
                            this.state.address_value !== "address-other" &&
                            "disabled"
                          }
                        />
                      </div>
                      <div className="break" />
                      <div className="f-field country-field auto50 country-width-50">
                        <div className="label">
                          <Translate value="backOffice_network_forms_country" />
                        </div>

                        <div className="select-container">
                          <Form.Control
                            as={CountryDropdown}
                            value={this.state.identification_country}
                            onChange={(identification_country) =>
                              this.safeSetState({
                                identification_country,
                                identification_country_valid: true,
                              })
                            }
                            disabled={
                              ((this.props.accountData.places &&
                                this.props.accountData.places.filter(
                                  (obj) => obj.name === "home"
                                )[0]?.address.street) ||
                                this.props.accountData.billingAddress
                                  ?.address) &&
                              this.state.address_value !== "address-other"
                            }
                          />
                        </div>
                      </div>
                      <div className="f-field auto50">
                        <div className="label">
                          <Translate value="backOffice_network_forms_zipCode" />
                        </div>
                        <Form.Control
                          required
                          name="identification_zipcode"
                          value={this.state.identification_zipcode}
                          isValid={this.state.identification_zipcode_valid}
                          onChange={this.handleOnChange.bind(
                            this,
                            /^\d{4}-\d{3}$/
                          )}
                          type="text"
                          disabled={
                            (((this.props.accountData.places &&
                              this.props.accountData.places.filter(
                                (obj) => obj.name === "home"
                              )[0]?.address.street) ||
                              this.props.accountData.billingAddress?.address) &&
                              this.state.address_value !== "address-other") ||
                            (!this.state.identification_country && "disabled")
                          }
                        />
                      </div>
                      <div className="item bottom item-margin-top-2rem">
                        <button
                          type="submit"
                          form="requestPhysicalCard-form"
                          disabled={
                            this.state?.identification_sent_to === "" ||
                            this.state?.identification_license_plate.length > 30
                          }
                        >
                          {I18n.t("requestCard_request")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            ) : (
              /*
                ASSOCIATE PHYSICAL CARD 
              */
              <Form
                id="requestPhysicalCard-form"
                onSubmit={this.handleOnSubmitAssociate.bind(this)}
              >
                <div className="content-section">
                  <div className="content">
                    <div className="item">
                      <div className="f-field">
                        <div className="label">
                          <Translate value="rfid_decimal" />
                        </div>
                        <Form.Control
                          required
                          name="rfid_decimal"
                          isValid={this.state.rfid_decimal_valid}
                          value={
                            this.state.rfid_decimal !== ""
                              ? this.state.rfid_decimal
                              : ""
                          }
                          onChange={this.handleOnChange.bind(this, /^[0-9]*$/)}
                          onKeyDown={(e) =>
                            (e.key === "e" || e.key === "+" || e.key === "-") &&
                            e.preventDefault()
                          }
                          type="number"
                        />
                      </div>

                      <div className="break" />

                      <div className="f-field">
                        <div className="label">
                          <Translate value="rfid_little_endian" />
                        </div>
                        <Form.Control
                          required
                          name="rfid_little_endian"
                          isValid={this.state.rfid_little_endian_valid}
                          onChange={this.handleOnChange.bind(this, /.*/)}
                          type="text"
                          value={this.state.rfid_little_endian}
                          disabled
                        />
                      </div>

                      <div className="f-field">
                        <div className="label">
                          <Translate value="rfid_big_endian" />
                        </div>
                        <Form.Control
                          required
                          name="rfid_big_endian"
                          isValid={this.state.rfid_big_endian_valid}
                          onChange={this.handleOnChange.bind(this, /.*/)}
                          type="text"
                          value={this.state.rfid_big_endian}
                          disabled
                        />
                      </div>

                      <div className="break" />

                      <div className="f-field">
                        <div className="label">
                          <Translate value="rfid_inverted_decimal" />
                        </div>
                        <Form.Control
                          required
                          name="rfid_inverted_decimal"
                          isValid={this.state.rfid_inverted_decimal_valid}
                          onChange={this.handleOnChange.bind(this, /^[0-9]*$/)}
                          value={this.state.rfid_inverted_decimal}
                          type="text"
                          disabled
                        />
                      </div>

                      <div className="break" />

                      <div className="f-field">
                        <div className="label">
                          <Translate value="addCard_cardNumber" />
                        </div>
                        <Form.Control
                          name="card_number"
                          value={this.state.card_number}
                          isValid={this.state.card_number_valid}
                          onChange={this.handleOnChange.bind(this, /.*^\S/)}
                          type="text"
                          required
                        />
                      </div>
                    </div>

                    <div className="item bottom">
                      <button type="submit" form="requestPhysicalCard-form">
                        <Translate value="backOffice_network_forms_submit_bt" />
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </div>
          <ConfirmBlock
            show={this.state.confirmBlock}
            onHide={() => {
              this.safeSetState({ confirmBlock: false });
            }}
            onSuccess={this.handleConfirmBlockSuccess}
            replacement={true}
            reasons={this.props?.reasonsCarryOverToRequestPhysicalCard}
            address={`${this.state.identification_address}, ${this.state.identification_number}`}
            addressCode={`${this.state.identification_zipcode} , ${this.state.identification_state}`}
            addressCountry={this.state.identification_country}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.app.brand,
  country: state.account.accountData.country,
  accountData: state.account.accountData,
});

export default connect(mapStateToProps, { setAlert })(RequestPhysicalCard);
